import {
  Initial,
  SEARCHED_PREMIUM_OFFERS,
  SearchedPremiumOffersProperties,
} from "redmond";
import { call, put, putResolve, select } from "redux-saga/effects";
import { trackEvent } from "../../../api/v0/analytics/trackEvent";
import { fetchPremiumCollectionOffersAvailability } from "../../../api/v0/offers/fetchPremiumCollectionOffersAvailability";
import { actions } from "../actions";
import { actions as rewardsActions } from "../../rewards/actions";
import { RequestStateUtils } from "../reducer";
import { transformToStringifiedQuery } from "../utils/queryStringHelpers";
import { getSearchedOfferTrackingProperties } from "../reducer/selectors";

export default function* fetchPremiumOffersShopSaga(
  action: actions.IFetchPremiumOffersShop
) {
  try {
    if (JSON.stringify(action.params) === "{}") return;

    // Update URL immediately with search parameters
    const shopParams = transformToStringifiedQuery({
      fromDate: action.params.stayDates.from,
      untilDate: action.params.stayDates.until,
      adultsCount: action.params.guests.adults,
      children: action.params.guests.children,
    });

    // Preserve isTravelApp parameter if present
    const finalParams = action.isTravelApp
      ? `${shopParams}&isTravelApp=true`
      : shopParams;

    action.history.replace({
      pathname: action.history.location.pathname,
      search: finalParams,
    });

    yield putResolve(rewardsActions.fetchRewardsAccounts(false));

    const response: Initial = yield call(
      fetchPremiumCollectionOffersAvailability,
      action.params
    );

    yield put(
      actions.setPremiumOffersShopResults(
        RequestStateUtils.success(action.params, response)
      )
    );

    const properties: SearchedPremiumOffersProperties = yield select(
      getSearchedOfferTrackingProperties
    );
    trackEvent({
      eventName: SEARCHED_PREMIUM_OFFERS,
      properties,
    });
  } catch (e) {
    const error = e instanceof Error ? e : new Error(e as string);
    yield put(
      actions.setPremiumOffersShopResults(
        RequestStateUtils.failed(action.params, error)
      )
    );
  }
}
